/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesContractResponseDto } from '../../models/sales-contract-response-dto';

export interface ContractsControllerFindByCode$Params {
  tenant: string;
  code: string;
}

export function contractsControllerFindByCode(http: HttpClient, rootUrl: string, params: ContractsControllerFindByCode$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContractResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, contractsControllerFindByCode.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('code', params.code, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesContractResponseDto>;
    })
  );
}

contractsControllerFindByCode.PATH = '/o2-sales/contracts/tenant/{tenant}/by-code/{code}';
